import React, { useState } from 'react';
import { Box, Button, lighten, Typography, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type DossierFormaliteProcessesHeaderProps = {
    organizationLabel?: string;
    onUpdateOrganization: () => void;
};

const DossierFormaliteProcessesHeader: React.FunctionComponent<DossierFormaliteProcessesHeaderProps> =
    function (props) {
        const { organizationLabel, onUpdateOrganization } = props;
        const [mouseHover, setMouseHover] = useState<boolean>(false);
        const { palette } = useTheme();

        const headerSx = {
            display: 'flex',
            alignItems: 'center',
            columnGap: '8px',
        };

        const organizationSx = {
            color: lighten(palette.secondary.main, 0.5),
        };

        const organization = (
            <Button
                variant="text"
                onClick={onUpdateOrganization}
                onMouseEnter={() => setMouseHover(true)}
                onMouseLeave={() => setMouseHover(false)}
                sx={{ display: 'flex', gap: '0 5px', alignItems: 'center' }}
            >
                <Typography
                    variant="l2dbodyxs"
                    sx={organizationSx}
                >
                    {organizationLabel ? `Greffe de ${organizationLabel}` : 'Greffe à définir'}
                </Typography>
                {mouseHover && (
                    <FaOptionIcon
                        icon={['fasl', 'pen']}
                        sx={{ fontSize: '12px', color: lighten(palette.secondary.main, 0.5) }}
                    />
                )}
            </Button>
        );

        return (
            <Box sx={headerSx}>
                Formalités
                {organization}
            </Box>
        );
    };

export default DossierFormaliteProcessesHeader;
